// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"af766a9a","732":"bae3ea27","977":"f85627ec"}[chunkId] + ".chunk.js";
};